module.exports = __webpack_public_path__ + "img/aac.c0e855e.svg";